import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=0698d45b"
import script from "./BarChart.ts?vue&type=script&lang=ts&external"
export * from "./BarChart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports